import { GuideContent } from './guide-content'
import { match } from '@st/pattern'
import { useProcess, useSelect } from '~/store'

export function PaymentGuidePage() {
  const content = useSelect('paymentGuide', (state) => state.content)
  const process = useProcess('paymentGuide')
  return (
    <main className="mx-auto max-w-3xl px-6 py-10">
      {match(content)
        .with({ status: 'loading' }, () => <p>Loading payment instructions…</p>)
        .with({ status: 'failed' }, () => (
          <div>
            <p>Payment instructions could not be loaded.</p>
            <button className="mt-3 underline" onClick={() => process.send({ type: 'retry' })}>
              Retry
            </button>
          </div>
        ))
        .with({ status: 'ready' }, ({ guide }) => {
          if (!guide) return <p>No payment instructions are available for this selection.</p>
          return (
            <article className="space-y-4 text-base leading-relaxed">
              <GuideContent blocks={guide.blocks} />
              {guide.paymentUrl && (
                <p>
                  <a
                    className="text-indigo-600 underline"
                    href={guide.paymentUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Open official payment website
                  </a>
                </p>
              )}
            </article>
          )
        })
        .with({ status: 'signedOut' }, () => (
          <>
            <h1 className="text-2xl font-semibold">Sign in to view payment instructions</h1>
            <p className="mt-4">
              Open your accountant’s secure checklist link and sign in, then return to this page.
            </p>
          </>
        ))
        .exhaustive()}
    </main>
  )
}
